export const getOCSFSeverityNameFromNumber = (t, value: number) => {
  console.log(`getOCSFSeverityNameFromNumber value: ${value}`);
  const result = (() => {
    switch (value) {
      case 1:
        // Informational message. No action required.
        return t("SEVERITY.INFORMATIVE");
      case 2:
        // The user decides if action is needed.
        return t("SEVERITY.LOW");
      case 3:
        // Action is required but the situation is not serious at this time.
        return t("SEVERITY.MEDIUM");
      case 4:
        // Action is required immediately.
        return t("SEVERITY.HIGH");
      case 5:
        // Action is required immediately and the scope is broad.
        return t("SEVERITY.CRITICAL");
      case 6:
        // An error occurred but it is too late to take remedial action.
        return t("SEVERITY.FATAL");
      default:
        // The event/finding severity is not mapped. See the severity attribute, which contains a data source specific value.
        return t("SEVERITY.UNCLASSIFIED");
    }
  })();
  console.log("getOCSFSeverityNameFromNumber returns:", result);
  return result;
}

interface URLParams {
  workflow?: string;
  port?: number;
}

export const fetchBaseProxyUrl = ({port}: URLParams) => {
  let baseURL;
  const url = window.location.origin;
  
  if (url.includes("localhost")) {
    // console.log("fetchBaseUrl Running in local development mode");
    // console.log(`fetchBaseUrl port: ${port} ${typeof(port)}`);
    baseURL = `http://localhost:${port}`;
    // console.log(`fetchBaseUrl baseURL: ${baseURL}`);
  } else {
    baseURL = url
  }
  // console.log(`baseURL: ${baseURL}`)
  return(baseURL)
}
  
export const fetchBaseUrl = ({port}: URLParams) => {
  let baseURL;
  const url = window.location.origin;
  
  if (url.includes("localhost")) {
    // console.log("fetchBaseUrl Running in local development mode");
    // console.log(`fetchBaseUrl port: ${port} ${typeof(port)}`);
    if (port != undefined || port != null) {
      baseURL = `http://localhost:${port}`;
    } else {
      baseURL = window.location.origin;
    }
    // console.log(`fetchBaseUrl baseURL: ${baseURL}`);
  } else {
    baseURL = url
  }
  // console.log(`baseURL: ${baseURL}`)
  return(baseURL)
}

export const menuIncludesHttp = (navigate, menuItem) => {
  if (menuItem.path.includes("WINDOW_DOMAIN")) {
    const newPath = fetchBaseUrl({}) + menuItem.path.split("WINDOW_DOMAIN")[1]
    window.open(newPath, "_blank", "noopener noreferrer");
  } else {
    window.open(menuItem.path, "_blank", "noopener noreferrer");
  }
}

export const navigateToPath = (navigate, menuItem, handleSetModel) => {
  if (menuItem.hasOwnProperty("parameter") && menuItem.parameter) {
    if (menuItem.path && menuItem.path?.includes("http")) {
      menuIncludesHttp(navigate, menuItem);
    } else {
      handleSetModel(menuItem.parameter);
      navigate(menuItem.path);
    }
  } else {
    if (menuItem.path && menuItem.path?.includes("http")) {
      menuIncludesHttp(navigate, menuItem);
    } else {
      navigate(menuItem.path);
    }
  }
};